import Dashboard from "layouts/dashboard";
import Maintenance from "layouts/maintenance";
import Vendors from "layouts/vendor-directory";
import Billing from "layouts/billing";
import Profile from "layouts/profile";
import SiteMap from "layouts/sitemaps";
import Local_Link from "layouts/local_link";
import Calendar from "layouts/Calendar";
import Library from "layouts/library";
import Reservations from "layouts/reservations";
import PetRegistry from "layouts/petregistry";
import Instructions from "layouts/instructions";
import Incidents from "layouts/incident";
import Resident_Directory from "layouts/resident_directory";
import searchRequests from "layouts/searchRequests";
import EventLog from "layouts/eventlog";
import Email from "layouts/email";

import Shop from "examples/Icons/Shop";
import Office from "examples/Icons/Office";
import Settings from "examples/Icons/Settings";
import Document from "examples/Icons/Document";
import CustomerSupport from "examples/Icons/CustomerSupport";
import Cube from "examples/Icons/Cube";
import Property from "layouts/manager/property";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";

const routes = [

  {
    type: "collapse",
    name: "Property",
    key: "property",
    route: "/user/properties",
    activePaths: ["/user/properties", "/user/concierge"],
    icon: <Shop size="12px" />,
    component: <Property />,
    noCollapse: true,
    children: [],
  },

  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   route: "/user/profile",
  //   icon: <CustomerSupport size="12px" />,
  //   component: <Profile />,
  //   noCollapse: true,
  // },

  // {
  //   type: "collapse",
  //   name: "Manage",
  //   key: "manage",
  //   route: "/user/manage",
  //   icon: <Shop size="12px" />,
  //   component: <SiteMap />,
  //   noCollapse: false,
  //   children: [
  //     {
  //       type: "item",
  //       name: "Calendar",
  //       key: "calendar",
  //       route: "/user/calendar",
  //       icon: <CalendarMonthIcon fontSize="small" />,
  //       component: <Calendar />,
  //     },
  //     {
  //       type: "item",
  //       name: "Library",
  //       key: "library",
  //       route: "/user/library",
  //       icon: <Document size="12px" />,
  //       component: <Library />,
  //     },
  //     {
  //       type: "item",
  //       name: "Reservations",
  //       key: "reservations",
  //       route: "/user/reservations",
  //       icon: <Cube size="12px" />,
  //       component: <Reservations />,
  //     },
  //     {
  //       type: "item",
  //       name: "Pet Registry",
  //       key: "pet-registry",
  //       route: "/user/pet-registry",
  //       icon: <Settings size="12px" />,
  //       component: <PetRegistry />,
  //     },
  //   ],
  // },

  // {
  //   type: "collapse",
  //   name: "Maintenance",
  //   key: "maintenance",
  //   route: "/user/maintenance",
  //   icon: <Settings size="12px" />,
  //   component: <Maintenance />,
  //   noCollapse: false,
  //   children: [
  //     {
  //       type: "item",
  //       name: "New Request",
  //       key: "new-maintenance",
  //       route: "/user/maintenance/new/request",
  //       icon: <Settings size="12px" />,
  //       component: <Maintenance />,
  //     },
  //     {
  //       type: "item",
  //       name: "Search Requests",
  //       key: "search-maintenance",
  //       route: "/user/maintenance/search/requests",
  //       icon: <Settings size="12px" />,
  //       component: <searchRequests />,
  //     },
  //     {
  //       type: "item",
  //       name: "Vendor Directory",
  //       key: "vendor-directory",
  //       route: "/user/maintenance/vendor/directory",
  //       icon: <Shop size="12px" />,
  //       component: <Vendors />,
  //     },
  //   ],
  // },

  // {
  //   type: "collapse",
  //   name: "Front Desk",
  //   key: "front-desk",
  //   route: "/user/front-desk",
  //   icon: <Shop size="12px" />,
  //   component: <SiteMap />,
  //   noCollapse: false,
  //   children: [
  //     {
  //       type: "item",
  //       name: "Event Log",
  //       key: "event-log",
  //       route: "/user/event/log",
  //       icon: <CustomerSupport size="12px" />,
  //       component: <EventLog />,
  //     },
  //     {
  //       type: "item",
  //       name: "Instructions",
  //       key: "instructions",
  //       route: "/user/instructions",
  //       icon: <Settings size="12px" />,
  //       component: <Instructions />,
  //     },
  //     {
  //       type: "item",
  //       name: "Incidents",
  //       key: "incidents",
  //       route: "/user/incidents",
  //       icon: <Settings size="12px" />,
  //       component: <Incidents />,
  //     },
  //   ],
  // },

  // {
  //   type: "collapse",
  //   name: "Communication",
  //   key: "communication",
  //   route: "/user/communicate",
  //   icon: <CustomerSupport size="12px" />,
  //   component: <Email />,
  //   noCollapse: false,
  //   children: [
  //     {
  //       type: "item",
  //       name: "Send Email",
  //       key: "send-email",
  //       route: "/user/communicate/send-email",
  //       icon: <CustomerSupport size="12px" />,
  //       component: <Email />,
  //     },
  //   ],
  // },
];

export default routes;